module.exports = __webpack_public_path__ + "img/Weapon_158.23d30afe.png";